import * as braze from '@braze/web-sdk';

document.addEventListener('DOMContentLoaded', () => {
  braze.initialize(window.gon.braze_api_sdk_key, {
    baseUrl: window.gon.braze_api_sdk_url,
    enableLogging: false, // set to `true` for debugging
    allowUserSuppliedJavascript: true
  });
  if (window.gon.user_id) {
    braze.changeUser(window.gon.user_id);
  }
  braze.automaticallyShowInAppMessages();
  braze.openSession();
});
